import { OfficeViewActionButtons, OfficeViewAdditionalLines, OfficeViewMiddleHeader, OfficeViewMiddleNumbers, OfficeViewSearchResults, SearchableOptions, OfficeViewCallResults, OfficeViewCallRecording, OfficeViewAnswerButtons, ListenWhisperBargeButtons } from 'dyl-components';
import React, { useState } from 'react';
import './index.scss';
import { Grid, Header } from 'semantic-ui-react';
import OfficeViewDropZone from './OfficeViewDropZone';
import OfficeViewCallerDetails from '../OfficeViewCallerDetails';

const LIMIT = 15;

const OfficeViewPhoneMiddle = ({
    onNumberClick,
    search,
    isSearchResultsVisible,
    page,
    searchFunction,
    onPersonSelect,
    onChangeSearch,
    onPageChange,
    cancelFunction,
    isSearchingContacts,
    contacts_searched_count,
    contact_lookup,
    callState,
    control,
    hangup,
    hangupDisabled,
    vmDropDisabled,
    transfer,
    transferDisabled,
    hold,
    holdDisabled,
    mute,
    muteDisabled,
    onSaveDisabled,
    callResultsDisabled,
    callTagDisabled,
    relatedToDisabled,
    currentCallPhoneNumber,
    duration,
    callRecording,
    onRemovePerson,
    onEmailClick,
    onTaskClick,
    onEventClick,
    onHotlistClick,
    hasIntegration,
    isInHotlist,
    logActivityForm,
    isLogActivityModalOpen,
    setIsLogActivityModalOpen,
    answer,
    ignore,
    callDirection,
    userCurrentCallDirection,
    actionButtons,
    lines,
    currentTime,
    onSelectCall,
    onUnholdCall,
    onAnswer,
    onReject,
    additionalLineSpace,
    onTransferCall,
    onNewContactClick,
    onChangeResults,
    onChangeNotes,
    onSaveResults,
    transferControl,
    onClickTransfer,
    transferValid,
    isReadingTransferDestinations,
    transferDestinations,
    searchTransfer,
    transferDirty,
    isSaveLoading,
    isTransferringCall,
    ignoreDisabled,
    answerDisabled,
    onClickToDial,
    isClickToDial,
    answerClick2Dial,
    isClickToDialAnswered,
    isCallActivityFormOpen,
    setIsCallActivityFormOpen,
    isPhoneSystemSupported,
    isInternalCall,
    currentCall,
    currentCallUUID,
    userPhoneCreds,
    callTagOptions,
    relatedToOptions,
    isPress1,
    isDialer,
    isShowingCallResultsForm = true,
    onDirectCustomerClick,
    vmDropOptions,
    isReadingVmDropOptions,
    onVmDrop,
    listenWhisperBargeButtons
}) => {
    const isUnverified = !(contact_lookup?.contact_id || contact_lookup?.account_id || contact_lookup?.user_id);
    const cnam = isUnverified ? contact_lookup?.name || contact_lookup?.extension || "" : "";
    const buttonCheck = isInternalCall ? (!isClickToDial || !isInternalCall || isClickToDialAnswered) : (!isClickToDial || isInternalCall || isClickToDialAnswered)
    const [isAdditionalLinesExpanded, setIsAdditionalLinesExpanded] = useState(false);
    const isListenCall = Boolean(listenWhisperBargeButtons);
    const middleHeader = !isDialer ? <OfficeViewMiddleHeader
        person={contact_lookup}
        onRemovePerson={onRemovePerson}
        onEmailClick={onEmailClick}
        onTaskClick={onTaskClick}
        onEventClick={onEventClick}
        onHotlistClick={onHotlistClick}
        hasIntegration={hasIntegration}
        isInHotlist={isInHotlist}
        logActivityForm={logActivityForm}
        isLogActivityModalOpen={isLogActivityModalOpen}
        setIsLogActivityModalOpen={setIsLogActivityModalOpen}
        callState={callState}
        unknown={{ unknown: isUnverified, name: cnam }}
        onNewContactClick={onNewContactClick}
        onClickToDial={onClickToDial}
        isCallActivityFormOpen={isCallActivityFormOpen}
        setIsCallActivityFormOpen={setIsCallActivityFormOpen}
        isPhoneSystemSupported={isPhoneSystemSupported}
        isInternalCall={isInternalCall}
        currentCall={currentCall}
        currentTime={currentTime}
        isCallHeld={actionButtons?.hold}
        currentCallUUID={currentCallUUID}
        userPhoneCreds={userPhoneCreds}
    
        onDirectCustomerClick={onDirectCustomerClick} /> : (
            <Grid>
                <Grid.Column>
                    <OfficeViewCallerDetails 
                        callState={callState}
                        person={contact_lookup}
                        onRemovePerson={onRemovePerson}
                        unknown={{ unknown: isUnverified, name: cnam }}
                        currentCall={currentCall}
                        currentCallUUID={currentCallUUID}
                        isDialer
                    />
                </Grid.Column>
            </Grid>
        );
    const commonCallComponents = (
        <>
            {callState !== "idle" && <div className='OfficeView__midContainer--space'></div>}
            {(callState === "hangup") &&
                <OfficeViewCallRecording
                    currentCallPhoneNumber={currentCallPhoneNumber}
                    duration={duration}
                    callRecording={callRecording}
                    isInternalCall={isInternalCall}
                    isDialer={isDialer}
                    isPrimaryPhone={contact_lookup?.contact_details?.phone?.find(phone => phone.phone === currentCallPhoneNumber)?.main} 
                    isListenCall={isListenCall}
                />
            }
            {((callState === "ringing" && callDirection === "outbound" && buttonCheck) || callState === "active") &&
                <OfficeViewActionButtons
                    hangup={hangup}
                    hangupDisabled={hangupDisabled}
                    vmDropDisabled={vmDropDisabled}
                    transfer={transfer}
                    transferDisabled={transferDisabled}
                    hold={hold}
                    holdDisabled={holdDisabled}
                    mute={mute}
                    muteDisabled={muteDisabled}
                    inboundCall={userCurrentCallDirection === "inbound"}
                    actionButtons={actionButtons}
                    transferControl={transferControl}
                    onClickTransfer={onClickTransfer}
                    isReadingTransferDestinations={isReadingTransferDestinations}
                    transferDestinations={transferDestinations}
                    searchTransfer={searchTransfer}
                    transferValid={transferValid}
                    transferDirty={transferDirty}
                    isTransferringCall={isTransferringCall}
                    isDialer={isDialer} 
                    vmDropOptions={vmDropOptions}
                    isReadingVmDropOptions={isReadingVmDropOptions}
                    onVmDrop={onVmDrop}
                    listenWhisperBargeButtons={listenWhisperBargeButtons}                    
                />   
            }
            {((callState === "ringing" && callDirection === "inbound") || (callState === "ringing" && isInternalCall && callDirection === "inbound")) &&
                <OfficeViewAnswerButtons
                    answer={answer}
                    ignore={ignore}
                    actionButtons={actionButtons}
                    ignoreDisabled={ignoreDisabled}
                    answerDisabled={answerDisabled}
                    press1={isPress1}
                    isDialer={isDialer} />}
            {(callDirection === "outbound" && isClickToDial && !isClickToDialAnswered && callState !== "active" && callState !== "hangup") &&
                <OfficeViewAnswerButtons
                    answer={answerClick2Dial}
                    ignore={ignore}
                    actionButtons={actionButtons}
                    answerDisabled={answerDisabled}
                    press1={isPress1}
                    isDialer={isDialer} />}
            {!listenWhisperBargeButtons && isShowingCallResultsForm && ((callState === "ringing" && callDirection === "outbound" && (!isClickToDial || isClickToDialAnswered) && !isInternalCall && !isDialer) || (callState === "active" && !isInternalCall) || (callState === "hangup" && !isInternalCall)) &&
                <OfficeViewCallResults
                    control={control}
                    onSaveDisabled={onSaveDisabled}
                    callResultsDisabled={callResultsDisabled}
                    callTagDisabled={callTagDisabled}
                    relatedToDisabled={relatedToDisabled}
                    onChangeResults={onChangeResults}
                    onChangeNotes={onChangeNotes}
                    onSave={onSaveResults}
                    isSaveLoading={isSaveLoading}
                    callTagOptions={callTagOptions}
                    relatedToOptions={relatedToOptions}
                    isDialer={isDialer} />}
        </>
    );
    if (isDialer) {
        return (
            <>
                {middleHeader}
                {commonCallComponents}
            </>
        )
    }
    
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div className='OfficeView__searchContainer'>
                <SearchableOptions
                    loading={isSearchingContacts}
                    search={search}
                    searchFunction={searchFunction}
                    cancelSearchFunction={cancelFunction}
                    searchPlaceholder={'Search by name or number'}
                    onChangeSearch={onChangeSearch}
                    isSearchResultsVisible={isSearchResultsVisible}
                    renderSearchResults={(
                        <OfficeViewSearchResults onPersonSelect={onPersonSelect} />
                    )}
                    isPaginationVisible={true}
                    paginationProps={{
                        boundaryRange: 0,
                        activePage: page,
                        ellipsisItem: null,
                        siblingRange: 2,
                        totalPages: Math.ceil(contacts_searched_count / LIMIT),
                        onPageChange
                    }}
                    floatingResults
                    disabled={(callState === "ringing" || callState === "active")}
                />
            </div>
            <div className='OfficeView__midContainer'>
                <OfficeViewDropZone 
                    compressionSize={additionalLineSpace} 
                    isCompressed={isAdditionalLinesExpanded} 
                    currentCallUUID={currentCallUUID}
                    content={(
                        <>
                            {contact_lookup || (contact_lookup === null && callState !== "idle") ? (
                            <>
                                {middleHeader}
                                {callState === "idle" && <OfficeViewMiddleNumbers person={contact_lookup} onNumberClick={onNumberClick} currentCallPhoneNumber={currentCallPhoneNumber}/>}
                            </>
                            ) : callState === "idle" && (
                                <div style={{display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center'}}>
                                    <Header as={"h2"}>No Active Call</Header>
                                </div>
                            )}
                            {commonCallComponents}
                        </>
                    )}
                />
            </div>
            <OfficeViewAdditionalLines 
                lines={lines} 
                currentTime={currentTime} 
                onSelectCall={onSelectCall} 
                onUnholdCall={onUnholdCall} 
                onAnswer={onAnswer} 
                onReject={onReject} 
                additionalLineSpace={additionalLineSpace}
                onTransferCall={onTransferCall}
                answerDisabled={answerDisabled}
                isExpanded={isAdditionalLinesExpanded}
                toggleExpansion={() => setIsAdditionalLinesExpanded((prevValue) => !prevValue)}
                userPhoneCreds={userPhoneCreds}
            />
        </div>

    )
}

export default OfficeViewPhoneMiddle;
